module.exports = __webpack_public_path__ + "img/260720945_4_9.b4ea1f1e.png";